var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row video-modals"},_vm._l((_vm.videos),function(video){return _c('VideoModal',{key:video.id,attrs:{"image":video.image,"video":video.video,"id":video.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }